import { render, staticRenderFns } from "./section-speed.vue?vue&type=template&id=1e046ac8&"
import script from "./section-speed.vue?vue&type=script&lang=js&"
export * from "./section-speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports